import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import React from 'react';
import { DataBox } from '@/components/boxes';
import { Text } from '@/components/typography';
export function OurMission() {
  const $ = _c(40);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["aboutUs"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("ourMission.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 lg:mb-6" anchorKey="ourMission.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("ourMission.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="mb-12 text-center text-gray-800 lg:mb-16">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="mx-auto max-w-192">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("ourMission.items.1.text");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("ourMission.items.1.title");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <DataBox text={t6} title={t7} />;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("ourMission.items.2.text");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("ourMission.items.2.title");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t9) {
    t11 = <DataBox text={t9} title={t10} />;
    $[23] = t10;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("ourMission.items.3.text");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("ourMission.items.3.title");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <DataBox text={t12} title={t13} />;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t11 || $[34] !== t14 || $[35] !== t8) {
    t15 = <div className="flex flex-col items-center justify-center gap-2 lg:flex-row lg:gap-8">{t8}{t11}{t14}</div>;
    $[33] = t11;
    $[34] = t14;
    $[35] = t8;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15 || $[38] !== t5) {
    t16 = <div className="px-4">{t5}{t15}</div>;
    $[37] = t15;
    $[38] = t5;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
}